import type { ReactNode } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, List, ListItemText } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

interface NavItemProps {
	title: string;
	path: string;
	icon?: ReactNode;
	info?: ReactNode;
}

interface NavSectionProps {
	data: NavItemProps[];
	collapsed?: boolean;
}

export default function NavSection({ data = [], collapsed = false, ...other }: NavSectionProps) {
	return (
		<Box {...other}>
			<List disablePadding sx={{ p: 1 }}>
				{data.map((item) => (
					<NavItem key={item.title} item={item} collapsed={collapsed} />
				))}
			</List>
		</Box>
	);
}

// ----------------------------------------------------------------------

function NavItem({ item, collapsed }: { item: NavItemProps; collapsed: boolean }) {
	const { title, path, icon, info } = item;

	return (
		<StyledNavItem
			component={RouterLink}
			to={path}
			sx={{
				justifyContent: collapsed ? 'center' : 'flex-start',
				px: collapsed ? 1 : 2,
				width: collapsed ? 48 : 1,
				mx: collapsed ? 'auto' : 0,
				'&.active': {
					color: 'text.primary',
					bgcolor: '#f2f2f7',
					fontWeight: 'fontWeightBold',
				},
			}}
		>
			<StyledNavItemIcon sx={{ mr: collapsed ? 0 : 2 }}>{icon && icon}</StyledNavItemIcon>

			{!collapsed && <ListItemText disableTypography primary={title} />}

			{!collapsed && info && info}
		</StyledNavItem>
	);
}
